import axios from 'axios';
import { CUSTOMER_ADMIN_API_BASE } from '../env';

export default function getCustomerMonthlyInvoices(customerId, facility, token) {
  return axios.get(`${CUSTOMER_ADMIN_API_BASE}/${customerId}/monthly-invoices`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      ...(facility ? { facility } : {}),
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/monthlyInvoices.js